import React, { createContext, useContext, useState, useCallback } from 'react';

const SuperUserContext = createContext(null);

// Código maestro para activar super usuario
const MASTER_CODE = '7193';

export function SuperUserProvider({ children }) {
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [superUserExpiry, setSuperUserExpiry] = useState(null);

  // Activar modo super usuario (dura 30 minutos)
  const activateSuperUser = useCallback((code) => {
    if (code === MASTER_CODE) {
      setIsSuperUser(true);
      const expiry = new Date(Date.now() + 30 * 60 * 1000); // 30 minutos
      setSuperUserExpiry(expiry);
      
      // Auto-desactivar después de 30 minutos
      setTimeout(() => {
        setIsSuperUser(false);
        setSuperUserExpiry(null);
      }, 30 * 60 * 1000);
      
      return true;
    }
    return false;
  }, []);

  // Desactivar modo super usuario
  const deactivateSuperUser = useCallback(() => {
    setIsSuperUser(false);
    setSuperUserExpiry(null);
  }, []);

  // Verificar código para una acción específica
  const verifyCode = useCallback((code) => {
    return code === MASTER_CODE;
  }, []);

  return (
    <SuperUserContext.Provider value={{
      isSuperUser,
      superUserExpiry,
      activateSuperUser,
      deactivateSuperUser,
      verifyCode,
      MASTER_CODE
    }}>
      {children}
    </SuperUserContext.Provider>
  );
}

export function useSuperUser() {
  const context = useContext(SuperUserContext);
  if (!context) {
    throw new Error('useSuperUser debe usarse dentro de SuperUserProvider');
  }
  return context;
}
